export type EnterpriseWorkspaceAccessState = 'pending' | 'guest' | 'registered' | 'authorized'

export function resolveEnterpriseWorkspaceAccess(
  token: string | null | undefined,
  isUserInfoReady: boolean,
  bizTeamId: number | string | null | undefined,
): EnterpriseWorkspaceAccessState {
  if (!token) return 'guest'
  if (!isUserInfoReady) return 'pending'
  return bizTeamId ? 'authorized' : 'registered'
}

/** 待接受邀请的注册用户仅可进入企业管理，不能绕过其他企业工作台功能的会员拦截。 */
export function canRenderEnterpriseWorkspace(
  accessState: EnterpriseWorkspaceAccessState,
  activeMenu: string,
  hasPendingInvitation: boolean,
) {
  return accessState === 'authorized'
    || (accessState === 'registered' && activeMenu === 'enterprise' && hasPendingInvitation)
}
